import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['element']

  connect() {}

  copyValues() {
    const targets = this.elementTargets
    targets.forEach((e) => {
      var container_id = e.getAttribute('data-container-id');
      var container = document.querySelector('#' + container_id);
      const formName = e.getAttribute('data-form-name');
      const dataElements = container.querySelectorAll('[data_target]');

      dataElements.forEach((de) => {
        const targetName = de.getAttribute('data_target');
        const element_id = `${formName}_${targetName}`
        const correspondingFormElement = document.getElementById(element_id);

        if (targetName == 'editable') {
          const content = de.innerHTML.trim()
          if (window.tiptapEditor) {
            window.tiptapEditor.commands.setContent(content)
            if (window._syncAndSaveEditor) window._syncAndSaveEditor()
          } else {
            var editorField = document.querySelector('.editable')
            const MediumEditor = window.MediumEditor
            var editor = MediumEditor ? MediumEditor.getEditorFromElement(editorField) : null
            if (editor) {
              editor.elements[0].innerHTML = content
              editor.trigger('editableInput', null, editor.elements[0])
              document.dispatchEvent(new KeyboardEvent('keyup', { key: 'Enter' }))
            }
          }
        } else {
          if (correspondingFormElement) {
            correspondingFormElement.value = de.innerHTML.trim().replace(/<[^>]*>?/gm, '');
          }
        }
      });
    });
  }
}
